











import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';

export default Vue.extend({
    name: 'LanguageSelectorTab',

    computed: {
        ...mapState(['language']),

		...mapGetters(['getSiteSupportedLanguageCountries'])
    },

    methods: {
        ...mapActions(['changeLanguage'])
    }
});
